module.exports = __webpack_public_path__ + "img/impresoraFiscal.d95d0b5d.png";